/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber17Small = createReactComponent("number-17-small", "IconNumber17Small", [
  ["path", { d: "M7 10l2 -2v8", key: "svg-0" }],
  ["path", { d: "M13 8h4l-2 8", key: "svg-1" }]
]);

export { IconNumber17Small as default };
//# sourceMappingURL=IconNumber17Small.js.map
